// extracted by mini-css-extract-plugin
module.exports = {"modalHeader":"historical-trend_modalHeader__LCsxT","chartContainer":"historical-trend_chartContainer__1NDrA","modalFooter":"historical-trend_modalFooter__63DK9"};